export const hasParent = (elem, classname) => {
  return !!(elem && classname && elem.parentElement && elem.parentElement.classList.contains(classname))
}

export const hasParents = (elem, classname) => {
  let isHas = hasParent(elem, classname)
  if (!isHas && elem.parentElement) {
    isHas = hasParents(elem.parentElement, classname)
  }
  return isHas
}

// 이벤트 전파 방지
export const preventEvent = (e) => {
  if (e && e.preventDefault) {
    e.preventDefault();
    e.stopPropagation();
  }
}